import http, { e } from "./http";
import loginService from "./login.service";

const userService = {
  getUsersPaged(model) {
    const token = loginService.getRawToken();

    var headers = {
      Authorization: "Bearer " + token,
    };

    return http.post(e("user/paged"), model, headers).then((r) => {
      return r.data;
    });
  },
  getCompanies() {
    const token = loginService.getRawToken();

    var headers = {
      Authorization: "Bearer " + token,
    };

    return http.get(e("user/companies"), null, headers).then((r) => {
      return r.data;
    });
  },
  getCompany() {
    const token = loginService.getRawToken();

    var headers = {
      Authorization: "Bearer " + token,
    };

    return http.get(e("user/company"), null, headers).then((r) => {
      return r.data;
    });
  },
  getRoles() {
    const token = loginService.getRawToken();

    var headers = {
      Authorization: "Bearer " + token,
    };

    return http.get(e("user/roles"), null, headers).then((r) => {
      return r.data;
    });
  },
  createUser(user) {
    const token = loginService.getRawToken();

    var headers = {
      Authorization: "Bearer " + token,
    };

    return http.post(e("user"), user, headers).then((r) => {
      return r.data;
    });
  },
  updateUser(user) {
    const token = loginService.getRawToken();

    var headers = {
      Authorization: "Bearer " + token,
    };

    return http.put(e("user"), user, headers).then((r) => {
      return r.data;
    });
  },
  deleteUser(idUser) {
    const token = loginService.getRawToken();

    var headers = {
      Authorization: "Bearer " + token,
    };

    return http.remove(e(`user/${idUser}`), headers).then((r) => {
      return r.data;
    });
  },
  forceChangePassword(model) {
    const token = loginService.getRawToken();

    var headers = {
      Authorization: "Bearer " + token,
    };

    return http.put(e("user/forcepassword"), model, headers).then((r) => {
      return r.data;
    });
  },
  changePassword(model) {
    const token = loginService.getRawToken();

    var headers = {
      Authorization: "Bearer " + token,
    };

    return http.put(e("user/password"), model, headers).then((r) => {
      return r.data;
    });
  },
  importUsers(data) {
    const token = loginService.getRawToken();

    var headers = {
      Authorization: "Bearer " + token,
    };

    return http.put(e("user/import"), data, headers).then((r) => {
      return r.data;
    });
  },
  getSampleLayoutUrl() {
    const token = loginService.getRawToken();
    return http.getWithAccessToken(e("user/samplelayout"), token);
  },
  requireChangePassword() {
    const token = loginService.getRawToken();

    var headers = {
      Authorization: "Bearer " + token,
    };

    return http.get(e("user/requirepassword"), null, headers).then((r) => {
      return r.data;
    });
  },
  saveNote(note) {
    const token = loginService.getRawToken();

    var headers = {
      Authorization: "Bearer " + token,
    };

    return http.post(e("user/note"), note, headers).then((r) => {
      return r.data;
    });
  },
  getNote(idToy) {
    const token = loginService.getRawToken();

    var headers = {
      Authorization: "Bearer " + token,
    };

    return http.get(e(`user/note/${idToy}`), null, headers).then((r) => {
      return r.data;
    });
  },
  createFavorite(idToy) {
    const token = loginService.getRawToken();

    var headers = {
      Authorization: "Bearer " + token,
    };

    return http.put(e(`user/favorite/${idToy}`), null, headers).then((r) => {
      return r.data;
    });
  },
  removeFavorite(idToy) {
    const token = loginService.getRawToken();

    var headers = {
      Authorization: "Bearer " + token,
    };

    return http.remove(e(`user/favorite/${idToy}`), headers).then((r) => {
      return r.data;
    });
  },
  sendResume() {
    const token = loginService.getRawToken();

    var headers = {
      Authorization: "Bearer " + token,
    };

    return http.put(e("user/resume"), null, headers).then((r) => {
      return r.data;
    });
  },
  foward(ids) {
    const token = loginService.getRawToken();

    var headers = {
      Authorization: "Bearer " + token,
    };

    return http
      .post(
        e("user/foward"),
        {
          ids,
        },
        headers
      )
      .then((r) => {
        return r.data;
      });
  },
  getBrochures() {
    const token = loginService.getRawToken();

    var headers = {
      Authorization: "Bearer " + token,
    };

    return http.get(e("user/brochures"), null, headers).then((r) => {
      return r.data;
    });
  },
};
export default userService;
